module.exports = __webpack_public_path__ + "img/Bärlin.3dec13fc.svg";